/**
 * Extract path from URL
 */
function getPathFromUrl(url) {
    try {
        // Handle relative URLs by prepending a base
        const urlObject = url.startsWith('http') ? new URL(url) : new URL(url, 'http://example.com');
        // Normalize: remove trailing slash except for root path
        const path = urlObject.pathname;
        return path === '/' ? path : path.replace(/\/$/, '');
    }
    catch {
        // If URL is invalid, return the original string
        return url;
    }
}
/**
 * Returns all token URLs mentioned in the securitySchemes, without the domain
 */
// Type guard for OAuth2 security scheme
function isOAuth2Scheme(scheme) {
    return scheme.type === 'oauth2';
}
// Validate token URL
function isValidTokenUrl(url) {
    return url.trim().length > 0;
}
function getOpenAuthTokenUrls(schema) {
    if (!schema?.components?.securitySchemes) {
        return [];
    }
    const securitySchemes = schema.components.securitySchemes;
    // Use Set from the start for better memory efficiency
    const tokenUrls = new Set();
    // Iterate through all security schemes
    for (const scheme of Object.values(securitySchemes)) {
        if (!isOAuth2Scheme(scheme)) {
            continue;
        }
        const flows = scheme.flows; // Type assertion no longer needed
        // Helper to safely add valid token URLs
        const addTokenUrl = (url) => {
            if (url && isValidTokenUrl(url)) {
                tokenUrls.add(getPathFromUrl(url));
            }
        };
        addTokenUrl(flows?.password?.tokenUrl);
        addTokenUrl(flows?.clientCredentials?.tokenUrl);
        addTokenUrl(flows?.authorizationCode?.tokenUrl);
    }
    return Array.from(tokenUrls);
}

export { getOpenAuthTokenUrls, getPathFromUrl };
